import styled from 'styled-components'

export const GeneralInformation = styled.div`
  /* global component styling */
  .container-spacing {
    margin-bottom: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      margin-bottom: 40px;
    }
  }

  .inner-grid {
    padding: 0;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    &.general-info-footer {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
        &:last-child {
          justify-content: flex-end;
        }
      }

      button {
        width: 100%;
        margin: 0;

        @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
          width: auto;
          margin-left: 20px;
        }
      }
    }
  }

  .general-info-opening {
    margin: 10px 0;
  }

  .no-margin {
    margin: 0;
  }

  .headline-container {
    position: relative;
    margin-bottom: 30px;

    .headline-alternative {
      margin-bottom: 0;

      &.has-specification {
        margin-bottom: 10px;
      }
    }

    .subject {
      color: ${ (props) => props.theme.colors['icon-grau1'] };
    }
  }

  .bookmark-general-information {
    position: absolute;
    top: -10px;
    right: -10px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      right: -20px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
      top: -20px;
      right: -30px;
    }
  }

  /* styleguide overrides / settings */
  p,
  ul.list-checkmark li {
    margin: 0 0 10px;
    display: flex;
    align-items: baseline;
    width: auto;

    &:last-child {
      margin-bottom: 0;
    }

    .tooltip {
      padding-left: 10px;
    }

    .contribution {
      margin-right: 10px;
    }

    li > span:last-child:not(.contribution) {
      position: relative;
      top: 3px;
    }
  }

  .headline-alternative {
    margin-bottom: 30px;
    /* prevent overlapping with bookmark */
    margin-right: 45px;
  }

  .more-link {
    margin-bottom: 10px;
    display: inline-block;
    cursor: pointer;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      margin-bottom: 0;
    }
  }

  .general-info-tooltip {
    margin-left: 10px;
  }

  .price-per-hour {
    margin-top: 10px;
  }

  .list-transparency-report {
    margin-bottom: 10px;

    .transparencyReport-tooltip {
      top: 2px;
      left: 10px;
    }

    li > strong {
      margin-left: 10px;
      white-space: nowrap;
    }
  }

  .list-contribution {
    margin-top: 10px;

    .contribution {
      margin-right: 10px;
    }

    strong {
      white-space: nowrap;
    }

    li > div > span:last-child:not(.contribution) {
      position: relative;
      top: 3px;
    }
  }

  .contact-persons{
    margin-top: 40px;
  }
`

export const ContactIcon = styled.span`
  color: ${ (props) => props.theme.colors['icon-grau1'] };
  margin-right: 20px;
`

export const TooltipContainer = styled.span`
  margin-left: 13px;
`

export const LastUpdate = styled.p`
  margin: 0;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
    text-align: ${ (props) => (props.type === 'hospital' ? 'right' : 'left') };
  }
`
export const QsrLink = styled.span`
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${ (props) => props.theme.colors['aok-gruen'] };

    > a {
      color: ${ (props) => props.theme.colors['aok-gruen'] };
    }
  }
`

export const CostEstimateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  & > button {
    margin: 0;

    @media ${ (props) => props.theme.breakpoints.devices.max.sm }, print {
      margin-top: 20px;
    }
  }
`
